// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
General
*/
.bd-example-row .row > .col,
.bd-example-row .row > [class^="col-"] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  background-color: rgba(39, 41, 43, 0.03);
  border: 1px solid rgba(39, 41, 43, 0.1);
}

.bd-example-row1 > .row:first-child {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.bd-example-row1 > .row:not(:first-child) {
  padding-bottom: 0.75rem;
}

.header-sticky {
  position: sticky;
  top: 0;
  height: 100px;
  background: white;
  display: flex;
  align-items: center;

  /* Link animation to the vertical scroll */
  animation: shrink-header linear forwards;
  animation-timeline: scroll();
  /* Control when the shrinking happens (e.g., first 100px of scroll) */
  animation-range: 0px 100px;
}

@keyframes shrink-header {
  to {
    height: 50px;
    background: #f0f0f0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}

option:disabled {
  color: #999; /* Change to your preferred color */
}

select:has(option[disabled]:checked) {
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/Forms.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;;EAEE,oBAAoB;EACpB,uBAAuB;EACvB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;;EAEnB,0CAA0C;EAC1C,wCAAwC;EACxC,4BAA4B;EAC5B,qEAAqE;EACrE,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;EAC3C;AACF;;AAEA;EACE,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,WAAW;AACb","sourcesContent":["/**\nGeneral\n*/\n.bd-example-row .row > .col,\n.bd-example-row .row > [class^=\"col-\"] {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  background-color: rgba(39, 41, 43, 0.03);\n  border: 1px solid rgba(39, 41, 43, 0.1);\n}\n\n.bd-example-row1 > .row:first-child {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.bd-example-row1 > .row:not(:first-child) {\n  padding-bottom: 0.75rem;\n}\n\n.header-sticky {\n  position: sticky;\n  top: 0;\n  height: 100px;\n  background: white;\n  display: flex;\n  align-items: center;\n\n  /* Link animation to the vertical scroll */\n  animation: shrink-header linear forwards;\n  animation-timeline: scroll();\n  /* Control when the shrinking happens (e.g., first 100px of scroll) */\n  animation-range: 0px 100px;\n}\n\n@keyframes shrink-header {\n  to {\n    height: 50px;\n    background: #f0f0f0;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  }\n}\n\noption:disabled {\n  color: #999; /* Change to your preferred color */\n}\n\nselect:has(option[disabled]:checked) {\n  color: #999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
